var g = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var f = (e, t, r) => t in e ? g(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, p = (e, t) => {
  for (var r in t || (t = {}))
    m.call(t, r) && f(e, r, t[r]);
  if (i)
    for (var r of i(t))
      y.call(t, r) && f(e, r, t[r]);
  return e;
};
var c = (e, t) => {
  var r = {};
  for (var n in e)
    m.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && i)
    for (var n of i(e))
      t.indexOf(n) < 0 && y.call(e, n) && (r[n] = e[n]);
  return r;
};
import { jsx as P, Fragment as N } from "react/jsx-runtime";
import { useState as h, useRef as j } from "react";
import { createPortal as x } from "react-dom";
import { f as A, u as C } from "./factory-ueRxoNOV.js";
import { u as R } from "./use-isomorphic-effect-CiIycTKV.js";
import { a as S } from "./use-merged-ref-n551Tfbr.js";
function d(e) {
  const t = document.createElement("div");
  return t.setAttribute("data-portal", "true"), typeof e.className == "string" && t.classList.add(...e.className.split(" ").filter(Boolean)), typeof e.style == "object" && Object.assign(t.style, e.style), typeof e.id == "string" && t.setAttribute("id", e.id), t;
}
function q(n) {
  var a = n, {
    target: e,
    reuseTargetNode: t
  } = a, r = c(a, [
    "target",
    "reuseTargetNode"
  ]);
  if (e)
    return typeof e == "string" ? document.querySelector(e) || d(r) : e;
  if (t) {
    const s = document.querySelector("[data-mantine-shared-portal-node]");
    if (s)
      return s;
    const u = d(r);
    return u.setAttribute("data-mantine-shared-portal-node", "true"), document.body.appendChild(u), u;
  }
  return d(r);
}
const v = {}, E = A((e, t) => {
  const l = C("Portal", v, e), { children: r, target: n, reuseTargetNode: a } = l, s = c(l, ["children", "target", "reuseTargetNode"]), [u, b] = h(!1), o = j(null);
  return R(() => (b(!0), o.current = q(p({ target: n, reuseTargetNode: a }, s)), S(t, o.current), !n && !a && o.current && document.body.appendChild(o.current), () => {
    !n && !a && o.current && document.body.removeChild(o.current);
  }), [n]), !u || !o.current ? null : x(/* @__PURE__ */ P(N, { children: r }), o.current);
});
E.displayName = "@mantine/core/Portal";
export {
  E as P
};
